import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../core/services/files.service';
import { DriverService } from '../../../core/services/driver.service';
import { AppUtils } from '../../../core/config/app.utils';
import { SupplierService } from '../../../core/services/supplier.service';
import { NzMessageService } from 'ng-zorro-antd/message';

const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_LEFT_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_LEFT_UPLOAD';
const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_RIGHT_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_RIGHT_UPLOAD';
const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_FRONT_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_FRONT_UPLOAD';
const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BACK_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BACK_UPLOAD';
const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BOOT_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BOOT_UPLOAD';
const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_DASHBOARD_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_DASHBOARD_UPLOAD';
const ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_INTERIOR_UPLOAD =
  'ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_INTERIOR_UPLOAD';

@Component({
  selector: 'app-vehicle-details-form',
  templateUrl: './vehicle-details-form.component.html',
  styleUrls: ['./vehicle-details-form.component.scss'],
})
export class VehicleDetailsFormComponent implements OnInit {
  @Output() addVehicleOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible = false;
  @Input() supplier: any;
  type: any;
  vehicleForm: FormGroup | any;
  formErrors: any;
  imageArrayList: any[] = [];
  imageArrayDetails: any[] = [
    { type: 'Front' },
    { type: 'Back' },
    { type: 'Left Side' },
    { type: 'Right Side' },
    { type: 'Boot' },
    { type: 'Dashboard' },
    { type: 'Interior Rear' },
  ];
  selectedImageType: any;
  imageUploading = false;

  // Image array list suffs
  frontImage: any = {
    type: 'front',
  };
  backImage: any = {
    type: 'back',
  };
  leftImage: any = {
    type: 'left',
  };
  rightImage: any = {
    type: 'right',
  };
  bootImage: any = {
    type: 'boot',
  };
  dashboardImage: any = {
    type: 'dashboard',
  };
  interiorImage: any = {
    type: 'interior rear',
  };
  frontLoading = false;
  backLoading = false;
  leftLoading = false;
  rightLoading = false;
  bootLoading = false;
  dashboardLoading = false;
  interiorLoading = false;

  editableVehicle: any;
  editableVehicleIndex: any;
  supplierVehicles: any[] = [];

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private driverService: DriverService,
    private supplierService: SupplierService,
    private message: NzMessageService,
  ) {
    this.formErrors = {
      vehicleModel: {},
      registerNumber: {},
      yearOfManufacture: {},
    };
  }

  ngOnInit(): void {
    this.initVehicleForm();
    this.driverService.supplierVehicleFormType.subscribe((res) => {
      this.type = res;
      if (res === 'edit') {
        this.supplierService.selectedVehicle.subscribe((res: any) => {
          this.editableVehicle = res;
          if (this.editableVehicle.vehicleModel) {
            this.supplierService.selectedVehicleIndex.subscribe((res: any) => {
              this.editableVehicleIndex = res;
            });
            this.vehicleForm.patchValue({
              vehicleModel: this.editableVehicle?.vehicleModel,
              registerNumber: this.editableVehicle?.registerNumber,
              yearOfManufacture: new Date(
                this.editableVehicle?.yearOfManufacture,
              ),
            });
            if (this.editableVehicle?.vehicleImages?.length > 0) {
              this.editableVehicle?.vehicleImages.forEach((img: any) => {
                switch (img.type) {
                  case 'front':
                    this.frontImage = img;
                    break;
                  case 'back':
                    this.backImage = img;
                    break;
                  case 'left':
                    this.leftImage = img;
                    break;
                  case 'right':
                    this.rightImage = img;
                    break;
                  case 'boot':
                    this.bootImage = img;
                    break;
                  case 'dashboard':
                    this.dashboardImage = img;
                    break;
                  case 'interior rear':
                    this.interiorImage = img;
                    break;
                }
              });
            }
          }
        });
      }
    });

    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      switch (res.type) {
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_DASHBOARD_UPLOAD:
          this.dashboardLoading = res.loading;
          break;
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_INTERIOR_UPLOAD:
          this.interiorLoading = res.loading;
          break;
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_LEFT_UPLOAD:
          this.leftLoading = res.loading;
          break;
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BACK_UPLOAD:
          this.backLoading = res.loading;
          break;
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_FRONT_UPLOAD:
          this.frontLoading = res.loading;
          break;
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_RIGHT_UPLOAD:
          this.rightLoading = res.loading;
          break;
        case ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BOOT_UPLOAD:
          this.bootLoading = res.loading;
          break;
      }
    });

    this.supplierService.supplierVehiclesOnChange.subscribe((res: any) => {
      this.supplierVehicles = res;
    });
  }

  initVehicleForm(): void {
    this.vehicleForm = this.fb.group({
      vehicleModel: [null, [Validators.required]],
      registerNumber: [null, [Validators.required]],
      yearOfManufacture: [null, [Validators.required]],
    });

    this.vehicleForm.valueChanges.subscribe((values: any) => {
      this.formErrors = AppUtils.getFormErrors(
        this.vehicleForm,
        this.formErrors,
      );
      // console.log(values);
    });
  }

  resetFormData(): void {
    this.vehicleForm.reset();
    this.frontImage = {
      type: 'front',
    };
    this.backImage = {
      type: 'back',
    };
    this.leftImage = {
      type: 'left',
    };
    this.rightImage = {
      type: 'right',
    };
    this.bootImage = {
      type: 'boot',
    };
    this.dashboardImage = {
      type: 'dashboard',
    };
    this.interiorImage = {
      type: 'interior rear',
    };
  }

  vehicleImageLeftOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_LEFT_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.leftImage = {
          type: 'left',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_LEFT_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  vehicleImageRightOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_RIGHT_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.rightImage = {
          type: 'right',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_RIGHT_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  vehicleImageFrontOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_FRONT_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.frontImage = {
          type: 'front',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_FRONT_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  vehicleImageBackOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BACK_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.backImage = {
          type: 'back',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BACK_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  vehicleImageDashboardOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(
        item.file,
        ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_DASHBOARD_UPLOAD,
      )
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.dashboardImage = {
          type: 'dashboard',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_DASHBOARD_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  vehicleImageBootOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BOOT_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.bootImage = {
          type: 'boot',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_BOOT_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  vehicleImageInteriorOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(
        item.file,
        ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_INTERIOR_UPLOAD,
      )
      .subscribe((res) => {
        this.message.create('success', `Image has been uploaded!`);
        const data = res as any;
        this.interiorImage = {
          type: 'interior rear',
          attach: { name: data.name, url: data.url },
        };
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_SINGLE_VEHICLE_IMAGES_INTERIOR_UPLOAD,
          loading: false,
        });
        this.selectedImageType = null;
      });

  setVehicleIndex(index: any): void {
    console.log(index);
  }

  checkHaveThisImageType(type: string): boolean {
    let isHave: any;
    this.imageArrayList.forEach((image) => {
      isHave = image.type === type;
    });
    return isHave;
  }

  setImageType(type: string): void {
    this.selectedImageType = type;
  }

  removeVehiclePhoto(type: string): void {
    switch (type) {
      case 'front':
        this.frontImage = {
          type: 'front',
        };
        break;
      case 'back':
        this.frontImage = {
          type: 'back',
        };
        break;
      case 'left':
        this.frontImage = {
          type: 'left',
        };
        break;
      case 'right':
        this.frontImage = {
          type: 'right',
        };
        break;
      case 'dashboard':
        this.frontImage = {
          type: 'dashboard',
        };
        break;
      case 'boot':
        this.frontImage = {
          type: 'boot',
        };
        break;
      case 'interior rear':
        this.frontImage = {
          type: 'interior rear',
        };
        break;
    }
    this.message.create('success', `Image has been removed!`);
    console.log('clicked!');
  }

  removeVehicle(): void {
    this.vehicleForm.reset();
    this.addVehicleOnChange.emit({ name: 'isVisible', value: false });
  }

  onAddVehicleDetails(event: any): void {
    switch (event.name) {
      case 'isVisible':
        break;
      case 'resp':
        break;
    }
  }

  cancel(): void {
    this.editableVehicle = null;
    this.supplierService.selectedVehicle.next({});
    this.resetFormData();
    this.isVisible = false;
    this.addVehicleOnChange.emit({ name: 'isVisible', value: false });
  }

  cancelConfirm(): void {
    this.isVisible = false;
    this.editableVehicle = null;
    this.supplierService.selectedVehicle.next({});
    this.resetFormData();
    this.addVehicleOnChange.emit({ name: 'isVisible', value: false });
  }

  onSubmit(): void {
    const vehicleData = this.vehicleForm.getRawValue();
    if (this.type === 'add') {
      this.supplierVehicles.push({
        ...vehicleData,
        vehicleImages: [
          this.backImage,
          this.bootImage,
          this.leftImage,
          this.rightImage,
          this.dashboardImage,
          this.frontImage,
          this.interiorImage,
        ],
        createdAt: new Date(),
      });
    } else if (this.type === 'edit') {
      this.supplierVehicles[this.editableVehicleIndex] = {
        ...vehicleData,
        vehicleImages: [
          this.backImage,
          this.bootImage,
          this.leftImage,
          this.rightImage,
          this.dashboardImage,
          this.frontImage,
          this.interiorImage,
        ],
        createdAt: new Date(this.editableVehicle.createdAt),
        updatedAt: new Date(),
      };
    }
    this.supplierService
      .updateSuppliers({
        _id: this.supplier,
        vehicles: this.supplierVehicles,
        updateType: `vehicle_${this.type}`,
      })
      .then((res) => {
        this.resetFormData();
        if (this.type === 'add') {
          this.message.create('success', `New Vehicle has been added`);
        } else {
          this.message.create('success', `Vehicle has been updated!`);
        }
        this.type = 'add';
        this.isVisible = false;
        this.editableVehicle = null;
        this.supplierService.selectedVehicle.next({});
        this.addVehicleOnChange.emit({ name: 'submit', value: false });
      });
  }

  handleOk(): void {}
}
